import {signInWithEmailAndPassword} from "firebase/auth";
import {auth} from "../../../firebaseConfig";

export const login = async ({ email, password }) => {
  await signInWithEmailAndPassword(auth, email, password);
}